import { NextPage } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useState } from 'react';
import LoginContainer from '../../react-components/login/container';
import inputGrid from '../../styles/input-grid.module.css';
import Layout from '../../react-components/layout';
import Password from '../../react-components/inputs/password';

const DEFAULT_ADMIN_PAGE = '/manage';

const AdminLogin: NextPage = () => {
  const [password, setPassword] = useState('');
  const router = useRouter();
  return (
    <>
      <Head>
        <title>Admin Login</title>
      </Head>
      <Layout>
        <LoginContainer
          header='Admin Login'
          endpoint='sessions/admin'
          loginData={{ password }}
          onLogin={() => {
            const redirect = new URL(window.location.href).searchParams.get('continue');
            router.push({ pathname: redirect ?? DEFAULT_ADMIN_PAGE });
          }}
        >
          <div className={inputGrid.inputGrid}>
            <Password
              placeholder='Password'
              required
              isNew={false}
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </div>
        </LoginContainer>
      </Layout>
    </>
  );
};

export default AdminLogin;
